import {PaginationResponsiveConfig} from '@shared/NewPagination';

export const ArticlesPaginationConfig: PaginationResponsiveConfig = {
  maxTotalPagesToRenderAllPages: 11,
  buttonsLimit: 7,
  keepNextPrevOnSameLineFromWidth: 1024,
  breakpoints: [
    {
      minWidth: 360,
      buttonsLimit: 8,
    },
    {
      minWidth: 480,
      buttonsLimit: 11,
    },
    {
      minWidth: 720,
      buttonsLimit: 13,
    },
    {
      minWidth: 1024,
      buttonsLimit: 11,
    },
    {
      minWidth: 1920,
      buttonsLimit: 17,
      maxTotalPagesToRenderAllPages: 17,
    },
  ],
};
